/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'

import { getSuperPlanStepIcon } from '@slite/components'

import { WebsiteCard } from '../../../components/Card/Card'

type WorkflowStepProps = {
  title: string
  type?: string | null
  children?: React.ReactNode
  className?: string
}

export function WorkflowStep({
  title,
  children,
  className,
  type,
}: WorkflowStepProps) {
  const IconToRender = getSuperPlanStepIcon(type ?? '')
  return (
    <WebsiteCard
      hoverOutline={false}
      className={classNames(
        'padding-vertical-12 padding-horizontal-16 width-full border-small border-alpha-shade-40',
        className
      )}
    >
      <div className="flexbox flexbox-align-start flexbox-column-gap-8 margin-bottom-4">
        <IconToRender className="flexbox-no-shrink margin-top-4 shade-05" />
        <div className="shade-05 font-weight-semibold">{title}</div>
      </div>
      {!!children && (
        <div
          className="shade-20 position-relative font-size-6"
          css={css`
            padding-left: 24px;
            &:before {
              position: absolute;
              content: ' ';
              height: 100%;
              width: 1px;
              background: linear-gradient(
                to bottom,
                var(--alpha-shade-40) 50%,
                transparent 50%
              );
              background-size: 2px 8px;
              left: 10px;
            }
          `}
        >
          {children}
        </div>
      )}
    </WebsiteCard>
  )
}
